// extracted by mini-css-extract-plugin
export default {"sidebar_wrapper":"sidebar_sidebar_wrapper__s1WdP","item":"sidebar_item__CFfoC","profile_item":"sidebar_profile_item__QOduL","active":"sidebar_active__JZKv7"};